(() => {
  const initVariety = (root) => {
    if (root.dataset.variety2Ready === 'true') return;
    root.dataset.variety2Ready = 'true';
    const inputs = [...root.querySelectorAll('[data-elite2-quantity]')];
    const selection = root.querySelector('[data-elite2-selection]');
    const heroUnitPrice = root.querySelector('.elite2-price > span');
    const syncPieces = (input) => {
      if (!input?.checked) return;
      const quantity = Number(input.value || 1);
      const boxLabel = quantity === 1 ? 'box' : 'boxes';
      const pieceCount = input.dataset.squares || '';
      const perPiece = input.dataset.perSquare || '';
      if (selection) selection.textContent = `${quantity} ${boxLabel} · ${pieceCount} pieces · ${perPiece} each`;
      if (heroUnitPrice) heroUnitPrice.innerHTML = `${pieceCount} pieces · <b>${perPiece}</b> each`;
    };
    inputs.forEach((input) => input.addEventListener('change', () => syncPieces(input)));
    syncPieces(inputs.find((input) => input.checked) || inputs[0]);
  };
  const initAll = (scope = document) => scope.querySelectorAll('.elite2--variety[data-elite2-root]').forEach(initVariety);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
